module.exports = __webpack_public_path__ + "img/sagam-sec.e504330d.png";